<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 md-small-size-100">
    <md-card class="md-card-stats">
      <md-card-header :md-alignment="footerFloat" class="md-card-header-icon card-position" :class="getClass(color)">
        <template>
          <div class="card-icon">
            <md-icon>{{ icon }}</md-icon>
          </div>
          <div class="card-split">
            <div class="left-section" >
              <p class="category">{{ titleExt }}</p>
              <h3 class="title" >{{ valueExt }}</h3>
            </div>
            <div class="right-section" >
              <p class="category">{{ title }}</p>
              <h3 class="title">{{ dataToShow }}</h3>
            </div>
          </div>
        </template>
      </md-card-header>
      <div class="footer-wrapper">
        <md-card-actions class="card-position" :md-alignment="footerFloat">
          <template>
            {{ footer }}
          </template>
        </md-card-actions>
      </div>
    </md-card>
  </div>
</template>
<script>
import {StatsCard} from "../../../components";
import filters from "../../../components/utils/filters";
import LoadingIconButton from "@/components/LoadingIconButton";

export default {
  components: {
    StatsCard,
    LoadingIconButton,
  },
  props:{
    footerFloat:{
      type: String,
      default: "right"
    },
    icon: {
      type: String,
      default: 'money',
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      default: ''
    },
    titleExt: {
      type: String,
      default: ''
    },
    value: {
      type: String | Number,
      default: 0
    },
    valueExt: {
      type: String | Number,
      default: 0
    },
    filter:{
      type: String,
      default: null
    },
    footer:{
      type: String,
      default: null
    },
  },
  computed:{
    dataToShow(){
      if(this.filter){
        return filters[this.filter](this.value);
      }
      return this.value;
    }
  },
  methods:{
    ...filters,
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
}
</script>
<style scoped lang="scss">
p.category {
  white-space: nowrap;
  overflow: hidden;
  padding-top: 10px;
}

.card-split {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.left-section {
  flex: 1;
  padding-left: 5px;
}

.right-section {
  flex: 1;
  padding-left: 20px;
}

.left-footer-section {
  flex: 1;
}

.right-footer-section {
  flex: 1;
}

.footer-section {
  text-align: right;
  font-size: small;
}

.footer-wrapper {
  margin-top: 5px;
  min-height: 40px;
}

.card-icon {
  margin-right: 0 !important;
}

.card-position {
  text-align: right;
}
</style>
